module.exports = __webpack_public_path__ + "media/styles/images/png/pencil-blue-40028382d1241ab69507b58dc87bd4f7.png";